import { rgba } from "polished";
import mainTheme from "@irati/ui/src/global/theme";
var letters = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
];
var colors = [
    mainTheme.colors.primary1_200,
    mainTheme.colors.secondary1_200,
    mainTheme.colors.tertiary.g_200,
    mainTheme.colors.tertiary.v_200,
    mainTheme.colors.tertiary.b_200,
    mainTheme.colors.tertiary.j_200,
    mainTheme.colors.tertiary.i_200,
    mainTheme.colors.tertiary.f_200,
    mainTheme.colors.tertiary.p_200,
    mainTheme.colors.tertiary.r_200,
    mainTheme.colors.tertiary.o_200,
    mainTheme.colors.tertiary.y_200
];
export default (function (name, deactivated) {
    if (deactivated === void 0) { deactivated = false; }
    var index = name ? letters.findIndex(function (letter) { return (letter === name.charAt(0).toLowerCase()); }) : 0;
    var number = index >= 0 ? index % colors.length : 0;
    var color = colors[number];
    return rgba(color, deactivated ? 0.5 : 1);
});
